export default __webpack_public_path__ + "static/media/essentialWebsiteSample1.c970c614.png";